import http from "../http-common";

class OfferDataService {

  filters(data) {
    console.log("HERE... OfferDataService filter with parameters "
    +"/nlocationCode: "+data.locationCode
    +"dayType: "+data.dayType
    +"dateFrom: "+data.dateFrom
    +"dateTo: "+data.dateTo
    +"timeFrom: "+data.timeFrom
    +"timeTo: "+data.timeTo
    +"volume: "+data.volume
    +"price: "+data.price);
    return http.get("/offer/api/filters?locationCode="+data.locationCode+"&dayType="+data.dayType
                                        +"&dateFrom="+data.dateFrom+"&dateTo="+data.dateTo
                                        +"&timeFrom="+data.timeFrom+"&timeTo="+data.timeTo
                                        +"&volume="+data.volume+"&price="+data.price);
  }

  getAll() {
    return http.get("/offer/api/offers");
  }

  getConsumption() {
    return http.get("/api/v1/hes-request/battery-discharge");
  }

  getProduction() {
    return http.get("/api/v1/hes-request/battery-charge");
  }
  getOfferList() {
    return http.get("/api/v1/hes-offer/list");
  }
  getReqList() {
    return http.get("/api/v1/hes-request/list");
  }

  get(id) {
    return http.get(`/offer/api/offers/${id}`);
  }

  create(data) {
    return http.post("/offer/api/offers", data);
  }

  buy(data) {
    return http.post("/api/v1/transaction/accept-offers", data);
  }

  getList() {
    return http.get("/api/v1/transaction/list")
  }

  import(data) {
    return http.post("/offer/api/offers", data);
  }

  update(id, data) {
    return http.put(`/offer/api/offers/${id}`, data);
  }

  delete(id) {
    return http.delete(`/offer/api/offers/${id}`);
  }

  tradingGraph() {
    return http.get("/api/v1/transaction/market-summary?countryCode=BG")
  }

  reqGraph() {
    return http.get("/request/api/market-summary?countryCode=BG")
  }

  offerGraph() {
    return http.get("/offer/api/market-summary?countryCode=BG")
  }

  deleteAll() {
    return http.delete(`/offer/api/offers`);
  }

  validate(id) {
    return http.get(`/api/v1/transaction/validation?requestCode=${id}`)
  } 

  findByCountryCode(countryCode) {
    return http.get(`/offer/api/offers/country?countryCode=${countryCode}`);
  }

  findByCompanyCode(companyCode) {
    return http.get(`/offer/api/offers/company?companyCode=${companyCode}`);
  }
  
  currentOfferMarket(c) {
    return http.get(`/offer/api/summary?countryCode=${c}`)
  }

  currentRequestMarket(c) {
    return http.get(`/request/api/summary?countryCode=${c}`)
  }

  flexOfferMarket(c) {
    return http.get(`/offer/api/market-summary?countryCode=${c}`)
  }

  flexRequestMarket(c) {
    return http.get(`/request/api/market-summary?countryCode=${c}`)
  }
  flexTransactionMarket(c) {
    return http.get(`/api/v1/transaction/market-summary?countryCode=${c}`)
  }

}

export default new OfferDataService();
